import { render } from "./ListPeriodo.vue?vue&type=template&id=1c608c07"
import script from "./ListPeriodo.vue?vue&type=script&lang=js"
export * from "./ListPeriodo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__